/**
 * 工作台（阶段 2 新 IA）相关翻译
 * 三栏：左会话地层 / 中对话流 / 右产物画布；任务控制页
 */

export const zh = {
  workbenchTitle: '工作台',
  strataTitle: '会话',
  strataSearch: '搜索会话…',
  // 会话在服务端不存在（已删除 / 链接有误）时的明确状态——不要与「空会话」混为一谈
  sessionMissingTitle: '会话不存在或已被删除',
  sessionMissingHint: '它可能已被删除，或者你打开的链接有误。',
  backToWorkbench: '回工作台',
  cmdSearch: '搜索、切换专家或执行命令…',
  railLibrary: '资源库',
  cmdGroupCommands: '命令',
  cmdGroupSessions: '会话',
  cmdNoResults: '没有匹配结果',
  cmdHint: '↑↓ 浏览 · ⏎ 打开 · esc 关闭',
  cmdNewSession: '新建会话',
  cmdGoTheme: '切换主题',
  sbOnline: '在线',
  sbOffline: '离线',
  sbCommands: '命令',
  aiBylineFallback: '助手',
  groupToday: '今天',
  groupYesterday: '昨天',
  groupThisWeek: '本周',
  groupEarlier: '更早',
  strataEmpty: '还没有会话',
  strataEmptyHint: '把任务交给专家，会话与产物会沉淀在这里',
  chipAwaiting: '待审核',
  chipRunning: '运行中',
  canvasArtifacts: '产物',
  canvasGallery: '画廊',
  canvasEmpty: '本次会话还没有产物',
  canvasEmptyHint: '专家执行任务时，产物会实时挂到这里',
  canvasWide: '宽屏对照',
  canvasCompact: '紧凑模式',
  artView: '视图',
  artCode: '代码',
  artExportPdf: '导出 PDF',
  canvasGalleryEmpty: '还没有任何产物',
  canvasGalleryEmptyHint: '去工作台发起一次任务试试',
  taskControlTitle: '任务控制',
  goToDecide: '去审核',
  planCardTitle: '执行计划',
  planStepCount: '{count} 个步骤',
  relatedArtifacts: '关联产物',
  footerTokensToday: '今日 {tokens}',
  footerTokensTodayCapped: '今日 {used} / {quota}',
  footerQuotaTitleCapped: '每日上限 {quota} tokens',
  footerQuotaTitleUnlimited: '未设配额，不限制',
}

export const en = {
  workbenchTitle: 'Workbench',
  strataTitle: 'Sessions',
  strataSearch: 'Search conversations…',
  sessionMissingTitle: 'Conversation not found',
  sessionMissingHint: 'It may have been deleted, or the link you opened is wrong.',
  backToWorkbench: 'Back to workbench',
  cmdSearch: 'Search, switch experts, or run commands…',
  railLibrary: 'Library',
  cmdGroupCommands: 'Commands',
  cmdGroupSessions: 'Conversations',
  cmdNoResults: 'No results',
  cmdHint: '↑↓ Navigate · ⏎ Open · esc Close',
  cmdNewSession: 'New conversation',
  cmdGoTheme: 'Switch theme',
  sbOnline: 'Online',
  sbOffline: 'Offline',
  sbCommands: 'Commands',
  aiBylineFallback: 'Assistant',
  groupToday: 'Today',
  groupYesterday: 'Yesterday',
  groupThisWeek: 'This week',
  groupEarlier: 'Earlier',
  strataEmpty: 'No conversations yet',
  strataEmptyHint: 'Hand a task to your experts — conversations and artifacts will settle here',
  chipAwaiting: 'To review',
  chipRunning: 'Running',
  canvasArtifacts: 'Artifacts',
  canvasGallery: 'Gallery',
  canvasEmpty: 'No artifacts in this conversation yet',
  canvasEmptyHint: 'Artifacts appear here as experts work',
  canvasWide: 'Wide view',
  canvasCompact: 'Compact view',
  artView: 'View',
  artCode: 'Code',
  artExportPdf: 'Export PDF',
  canvasGalleryEmpty: 'No artifacts yet',
  canvasGalleryEmptyHint: 'Start a task in the workbench',
  taskControlTitle: 'Task Control',
  goToDecide: 'Go to review',
  planCardTitle: 'Execution plan',
  planStepCount: '{count} steps',
  relatedArtifacts: 'Related artifacts',
  footerTokensToday: 'Today {tokens}',
  footerTokensTodayCapped: 'Today {used} / {quota}',
  footerQuotaTitleCapped: 'Daily limit {quota} tokens',
  footerQuotaTitleUnlimited: 'No quota set, unlimited',
}

export const ja = {
  workbenchTitle: 'ワークベンチ',
  strataTitle: 'セッション',
  strataSearch: '会話を検索…',
  sessionMissingTitle: '会話が見つかりません',
  sessionMissingHint: '削除されたか、開いたリンクが正しくない可能性があります。',
  backToWorkbench: 'ワークベンチに戻る',
  cmdSearch: '検索・専門家の切替・コマンド実行…',
  railLibrary: 'ライブラリ',
  cmdGroupCommands: 'コマンド',
  cmdGroupSessions: 'セッション',
  cmdNoResults: '結果なし',
  cmdHint: '↑↓ 移動 · ⏎ 開く · esc 閉じる',
  cmdNewSession: '新規会話',
  cmdGoTheme: 'テーマ切替',
  sbOnline: 'オンライン',
  sbOffline: 'オフライン',
  sbCommands: 'コマンド',
  aiBylineFallback: 'アシスタント',
  groupToday: '今日',
  groupYesterday: '昨日',
  groupThisWeek: '今週',
  groupEarlier: 'それ以前',
  strataEmpty: '会話はまだありません',
  strataEmptyHint: 'タスクを専門家に任せると、会話と成果物がここに蓄まります',
  chipAwaiting: '審査待ち',
  chipRunning: '実行中',
  canvasArtifacts: '産物',
  canvasGallery: 'ギャラリー',
  canvasEmpty: 'この会話にはまだ産物がありません',
  canvasEmptyHint: '専門家の実行に合わせて産物がここに並びます',
  canvasWide: 'ワイド表示',
  canvasCompact: 'コンパクト表示',
  artView: '表示',
  artCode: 'コード',
  artExportPdf: 'PDF 書き出し',
  canvasGalleryEmpty: '産物はまだありません',
  canvasGalleryEmptyHint: 'ワークベンチでタスクを開始してみましょう',
  taskControlTitle: 'タスク管理',
  goToDecide: '審査へ',
  planCardTitle: '実行計画',
  planStepCount: '{count} ステップ',
  relatedArtifacts: '関連成果物',
  footerTokensToday: '今日 {tokens}',
  footerTokensTodayCapped: '今日 {used} / {quota}',
  footerQuotaTitleCapped: '1日の上限 {quota} tokens',
  footerQuotaTitleUnlimited: 'クォータ未設定・無制限',
}
